export interface ReportBarRow {
  label: string;
  hours: string;
  /** CSS width, e.g. `'92%'`, sized relative to the largest row in the set. */
  width: string;
  highlight?: boolean;
}

/** A flat, borderless mini bar chart used to stand in for a real report screenshot. */
export function ReportBars({ rows }: { rows: ReportBarRow[] }) {
  return (
    <div className="space-y-3">
      {rows.map((row) => (
        <div key={row.label}>
          <div className="flex items-center justify-between text-label text-muted">
            <span>{row.label}</span>
            <span
              className={row.highlight ? 'font-mono tabular-nums text-gold-deep' : 'font-mono tabular-nums'}
            >
              {row.hours}
            </span>
          </div>
          <div className="mt-1 h-1.5 rounded-full bg-surface">
            <div
              className={row.highlight ? 'h-1.5 rounded-full bg-gold' : 'h-1.5 rounded-full bg-ink/60'}
              style={{ width: row.width }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
